import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { installPersistence, hydrateFromServer } from './lib/persistence';
import './index.css';

// Hydrate persisted dashboard state from the dev server's state file BEFORE
// first render, so admin data survives reloads regardless of origin/port.
async function bootstrap() {
  installPersistence();
  await hydrateFromServer();

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

void bootstrap();
